<ng-container *transloco="let t">
  @if (colorVariants$ | async) {
    <span class="fixed-space-8" aria-hidden="true"></span>
    @if (showLabel) {
      <h2 class="label text-gray-05">{{ t('hint_color') }}</h2>
      <span class="fixed-space-4" aria-hidden="true"></span>
    }
    <nav
      class="product-color-variants-component"
      [class.mobile]="(biggerThan$ | async)?.xs"
      [class.widescreen]="(biggerThan$ | async)?.mobileL">
      <ul class="flex flex-row variant-list">
        @for (
          variant of (productOptions$ | async)?.color_hex;
          track variant;
          let pos = $index
        ) {
          @if (isVariantAvailable(variant.code)) {
            <li
              class="flex flex-col variant-card"
              [class.selected]="isVariantSelected(variant.code)">
              @if (displayMode === 'icon' || 'small') {
                <div
                  class="link"
                  [title]="(variant.name | translateColor) || ''"
                  href=""
                  (click)="switchVariant(variant.code)">
                  @if (variant?.name) {
                    <div class="icon-wrap full-width flex align-center justify-start">
                      <div
                        class="icon color"
                        [class.stay-small]="displayMode === 'small'"
                        aria-hidden="true"
                        [style.background-color]="variant.code || '#FFF'"></div>
                    </div>
                  }
                </div>
              }
            </li>
          }
        }
      </ul>
    </nav>
  }
</ng-container>
